// import React, { useState } from "react";

// const Pagination = ({ totalPages, currentPage, setCurrentPage }) => {
//   const changePage = (newPage) => {
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//     if (currentPage === totalPages) {
//       setCurrentPage(1);
//     }
//     window.scroll({
//       top: 50,
//       behavior: "smooth",
//     });
//   };
//   return (
//     <>
//       <div className="flex justify-center mt-4">
//         <ul class="font-[sans-serif] flex mx-auto w-max mt-4">
//           <span className="py-1">
//             {[...Array(totalPages)].map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => changePage(index + 1)}
//                 className={`px-3 mx-0.5 py-1 border rounded ${
//                   currentPage === index + 1
//                     ? "bg-green-500 text-white"
//                     : "bg-white text-green-500"
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </span>
//           <button
//             onClick={() => changePage(currentPage + 1)}
//             class="p-1 border-2 border-black rounded flex items-center justify-center shrink-0 cursor-pointer text-sm font-semibold text-[#333] hover:bg-gray-50"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               class="w-3 fill-current rotate-180"
//               viewBox="0 0 55.753 55.753"
//             >
//               <path
//                 d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
//                 data-original="#000000"
//               />
//             </svg>
//           </button>
//         </ul>
//       </div>
//     </>
//   );
// };
// export default Pagination;

// import React from "react";
// import Typography from "@mui/material/Typography";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";

// const PaginationComponent = ({ totalPages, currentPage, setCurrentPage }) => {
//   const handleChange = (event, value) => {
//     if (value > 0 && value <= totalPages) {
//       setCurrentPage(value);
//     }
//   };

//   return (
//     <Stack spacing={2}>
//       <Pagination
//         count={totalPages}
//         page={currentPage}
//         onChange={handleChange}
//         siblingCount={1}
//         boundaryCount={1}
//         showFirstButton
//         showLastButton
//       />
//     </Stack>
//   );
// };

// export default PaginationComponent;

import React from "react";

const Pagination = ({ totalPages, currentPage, setCurrentPage }) => {
  const changePage = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
    if (currentPage === totalPages) {
      setCurrentPage(1);
    }
    window.scroll({
      top: 50,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex justify-center gap-2 mt-8">
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => changePage(index + 1)}
          className={`w-8 h-8 border text-sm transition ${
            currentPage === index + 1
              ? "bg-[#C9A227] text-white"
              : "hover:bg-[#C9A227] hover:text-white"
          }`}
        >
          {index + 1}
        </button>
      ))}

      <button
        onClick={() => changePage(currentPage + 1)}
        className="px-3 border text-sm hover:bg-[#C9A227] hover:text-white transition"
      >
        Next Page
      </button>
    </div>
  );
};

export default Pagination;
